export class LowInfoContactsLiensMRel {
  id: number;
  relation?: string;
  flagDelete?: number;
}
